/**
 * This is a local restriction adapter that resolves true or false
 * depending on whether or not the user is considered logged in
 * according to @cube/authn
 *
 * The restriction can be defined like so
 * authn
 *
 */
import { getSessionSync } from '@cube/authn';

export const NAME = '^authn$';

export default function isAllowed() {
	let session = getSessionSync();
	return session ? session.loggedIn === true : false;
}


// WEBPACK FOOTER //
// ../node_modules/@cube/restrictions/src/adapters/authn/index.js